import type { FC, ReactNode } from 'react';
import React from 'react';

import styled from '@emotion/styled';

import { Box, FontWeight, SERIF_FONT_FAMILY, Text } from '@clutter/clean';

import { TOKENS } from '@root/components/www/home/tokens';

const LeftQuote = styled.div`
  font-family: ${SERIF_FONT_FAMILY};
  transform: translate(-8px, -8px);
  font-size: 40px;
`;

const RightQuote = styled.div`
  font-family: ${SERIF_FONT_FAMILY};
  font-size: 40px;
  line-height: 0;
  transform: translate(8px, 8px);
`;

const DarkSlide = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${TOKENS.space[24]};
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
  padding: 0 ${TOKENS.space[16]};
  text-align: center;
`;

const DarkSlideHeadline = styled.h2`
  margin: 0;
  font-family: ${TOKENS.font.display};
  font-weight: 500;
  font-size: clamp(27px, calc(27px + 13 * ((100vw - 375px) / 1065)), 40px);
  line-height: clamp(34px, calc(34px + 16 * ((100vw - 375px) / 1065)), 50px);
  color: ${TOKENS.color.onDark};
`;

const DarkQuote = styled.p`
  margin: 0;
  max-width: 560px;
  font-family: ${TOKENS.font.sans};
  font-size: 17px;
  line-height: 1.45;
  color: ${TOKENS.color.onDarkMuted};
`;

const DarkAuthor = styled.p`
  margin: 0;
  font-family: ${TOKENS.font.sans};
  font-size: 15px;
  line-height: 1.4;
  font-weight: ${FontWeight.Medium};
  color: ${TOKENS.color.onDark};
`;

export const ReviewCard: FC<{
  title?: ReactNode;
  quote: ReactNode;
  reviewer: ReactNode;
  onDark?: boolean;
}> = ({ title, quote, reviewer, onDark }) => {
  if (onDark) {
    return (
      <DarkSlide>
        {title ? <DarkSlideHeadline>{title}</DarkSlideHeadline> : null}
        <DarkQuote>{quote}</DarkQuote>
        <DarkAuthor>{reviewer}</DarkAuthor>
      </DarkSlide>
    );
  }

  return (
    <Box
      width="100%"
      maxWidth="480px"
      minWidth="240px"
      margin="0 auto"
      padding="0 8px"
      textAlign="center"
    >
      {title && <Text.Title size="small">{title}</Text.Title>}
      <Box.Flex position="relative" padding="24px 0 0">
        <LeftQuote>“</LeftQuote>
        <Text.Body>{quote}</Text.Body>
        <Box.FlexItem alignSelf="flex-end">
          <RightQuote>”</RightQuote>
        </Box.FlexItem>
      </Box.Flex>
      <Text.Body weight={FontWeight.Medium}>{reviewer}</Text.Body>
    </Box>
  );
};
